import { isMobile, isMobileLandscape } from '../../shared/utilities';

import { createSlice } from '@reduxjs/toolkit';

/**
 * Window width below which we use mobile view. Note that the wrapping is also
 * dictated by Material UI wrapping the divs, but I can't immediately find where
 * that happens.
 */

export interface IViewportState {
  /** Viewport width. */
  width: number;
  /** Value indicating whether to use mobile phone layout. */
  isMobile: boolean;
  /** Value indicating whether a mobile is in landscape orientation. */
  isMobileLandscape: boolean;
}

const currentViewportState = (): IViewportState => ({
  width: window.innerWidth,
  isMobile: isMobile(window.innerWidth, window.innerHeight),
  isMobileLandscape: isMobileLandscape(window.innerHeight)
});

const initialState: IViewportState = currentViewportState();

export const viewportSlice = createSlice({
  name: 'viewport',
  initialState,
  reducers: {
    updateViewport: (state: IViewportState, action: {}) => {
      const current = currentViewportState();
      state.width = current.width;
      state.isMobile = current.isMobile;
      state.isMobileLandscape = current.isMobileLandscape;
    }
  }
});

export const { updateViewport } = viewportSlice.actions;
export default viewportSlice.reducer;
